import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef } from '@angular/core';
import { NavigationEnd, Router, Event } from '@angular/router';

import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';

import { HeaderModel, HeaderStoreModel } from './header.model';

import { State } from '../../reducers/index';
import { Booking } from '../../actions/booking.action';

@Component({
  selector: 'consentz-header-component',
  templateUrl: './header.template.html',
  styleUrls: ['./header.styles.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  public model: HeaderModel = new HeaderModel(JSON.parse(localStorage.getItem('currentBookingOptions')));
  public storeData: HeaderStoreModel = new HeaderStoreModel();

  constructor(
    private router: Router,
    private cdr: ChangeDetectorRef,
    private store: Store<State>
  ) {
    // subscribtion on header permissions and widget options
    this.storeData.permission$ = store.select<any>('header');
    this.storeData.subscribtion.booking$ = store.select<any>('booking').subscribe((data: Booking) => {
      if (Object.keys(data).find(key => key === 'primaryFontColour')) {
        this.model.currentBookingOptions = data;
      }
      this.model.timeoutDateUpdate = setTimeout(() => {
        // set dynamic color for interface
        let style: any = null;
        if (document.querySelector('#css-dynamic-class-progress')) {
          style = document.querySelector('#css-dynamic-class-progress');
        } else {
          style = document.createElement('style');
          style.type = 'text/css';
          style.id = 'css-dynamic-class-progress';
        }
        style.innerHTML = `.css-dynamic-class-progress { background-color: ${this.model.currentBookingOptions.primaryInterfaceColour}!important; }`;
        document.getElementsByTagName('head')[0].appendChild(style);

        const element: any = document.querySelector('.ui-progressbar-value');
        if (element) {
          element.classList.add('css-dynamic-class-progress');
        }
      });
    });
  }

  public changeData(data: any): void {
    this.model.valueOfCurrentRouterLink = data;
  }

  public ngOnInit(): void {
    this.routerLinkChange();
  }
  // unsubscribe from store
  public ngOnDestroy(): void {
    clearTimeout(this.model.timeoutDateUpdate);
    this.storeData.subscribtion.booking$.unsubscribe();
    this.storeData.subscribtion.router$.unsubscribe();
    clearTimeout(this.model.timeoutDateUpdate);
  }

  // Get router value changes and set progress value
  private routerLinkChange(): void {
    this.changeData(this.model.steps[this.router.url.slice(1).split('/')[1]]);
    this.storeData.subscribtion.router$ = this.router.events
      .filter((event: Event) => event instanceof NavigationEnd)
      .map(() => this.router)
      .subscribe((event: any) => {
        this.changeData(this.model.steps[event.routerState.snapshot.url.toString().slice(1).split('/')[1]]);
      });
  }
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/header/header.component.ts